import { Image } from 'antd';
import { useTranslation } from 'react-i18next';
import Logo from '../../../assets/company/logo.png';
import { useNavigate } from 'react-router-dom';

const ResetPasswordHeader = () => {
  const { t } = useTranslation('signIn');
  const navigate = useNavigate();

  return (
    <>
      <Image preview={false} src={Logo} width={120} onClick={() => navigate('/')} className='cursor-pointer' />
      <p className='mt-4 mb-4 text-base font-medium'>{t('passwordReset')}</p>
    </>
  );
};

export default ResetPasswordHeader;
